import { render } from "./division-settings.vue?vue&type=template&id=be686f24"
import script from "./division-settings.vue?vue&type=script&lang=js"
export * from "./division-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__